import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const AlreadySubscribed = () => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Already Subscribed - AI Notes</title>
      </Helmet>
      <div style={{
        background: 'linear-gradient(135deg, rgba(232, 232, 232, 0.92) 0%, rgba(248,250,252,0.95) 100%)',
        minHeight: 'auto',
        padding: '100px 20px 40px 20px',
        margin: '0',
        width: '100%'
      }}>
        <div style={{ width: '100%', maxWidth: 'none' }}>
          {/* Header Section */}
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h1 style={{
                fontSize: '2.5rem',
                fontWeight: '300',
                color: '#2d3748',
                marginBottom: '0',
                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
              }}>
                You're Already Subscribed ✅
              </h1>
            </Col>
          </Row>
          
          {/* Confirmation Card */}
          <Row className="justify-content-center">
            <Col lg={8} md={10}>
              <div style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,250,252,0.9) 100%)',
                borderRadius: '16px',
                padding: '2rem',
                boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                border: 'none'
              }}>
                {/* Message */}
                <div className="text-center mb-4">
                  <div style={{
                    color: '#4a5568',
                    fontSize: '0.95rem',
                    fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                    lineHeight: '1.6'
                  }}>
                    Good news! You're already on the list.
                  </div>
                </div>

                {/* Help text - 60% of card width */}
                <div style={{
                  width: '60%',
                  minWidth: '300px',
                  maxWidth: '1000px',
                  margin: '0 auto 1.5rem auto'
                }}>
                  <div style={{
                    backgroundColor: 'rgba(102, 126, 234, 0.05)',
                    border: '2px solid rgba(102, 126, 234, 0.2)',
                    borderRadius: '8px',
                    padding: '1.25rem 1.5rem'
                  }}>
                    <div style={{
                      fontSize: '0.9rem',
                      color: '#4a5568',
                      fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                      lineHeight: '1.6'
                    }}>
                      Don't see our emails? Check your spam folder for emails from 10am CT. You can also send an email to{' '}
                      <a
                        href="mailto:elliot@newsletter.elliotkoss.com"
                        style={{ color: '#667eea', textDecoration: 'none' }}
                      >
                        elliot@newsletter.elliotkoss.com
                      </a>. This helps signal to your email service that it's a legit email.
                    </div>
                  </div>
                </div>

                {/* Action Button */}
                <div className="text-center">
                  <Link 
                    to="/ai-notes"
                    style={{
                      backgroundColor: '#667eea',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '14px 32px',
                      fontSize: '1rem',
                      fontWeight: '500',
                      fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                      textDecoration: 'none',
                      display: 'inline-block',
                      transition: 'all 0.2s ease',
                      minWidth: '160px'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = '#5a67d8';
                      e.target.style.transform = 'translateY(-1px)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = '#667eea';
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    Back to AI Notes
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default AlreadySubscribed;
